




























import { Vue, Component } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import ScheduleDataTable from "../../components/DataTables/ScheduleDataTable.vue";
import * as data from "../../_store/data.module";
import { bus } from "../../main";
import * as temp from "../../_store/temp.module";
import { userUtils } from "../../_utils/userUtils";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import { InstituteInfo } from "../../_models/instituteInfo";

@Component({
  components: {
    CardTitle,
    ScheduleDataTable
  }
})
export default class SchedulazioneWorkshop extends Vue {
  private dataTableParams: any;
  private titleParams: object;
  private createDialogParams: object;
  private listaIscrizioniWorkshop: any;
  private listaGiorni: any;
  private listaTurni: any;

  private changed: boolean;
  private errorOccured: boolean;

  private userInfo:any;

  constructor() {
    super();
    this.titleParams = {
      title: "SCHEDULAZIONE WORKSHOP",
      cols: "10",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.dataTableParams = {
      headers: [
        {
          text: "Azienda",
          value: "denominazioneAzienda"
        },
        {
          text: "Settore",
          value: "nomeArticolazione"
        },
        {
          text: "Giorno",
          value: "giornoSelect"
        },
        {
          text: "Turno",
          value: "turnoSelect"
        },
        // {
        //   text: "Link Stanza",
        //   value: "linkStanzaButton"
        // },
        {
          text: "Referente",
          value: "referente"
        },
        {
          text: "Email Referente",
          value: "emailReferente"
        },
        {
            text: "Presente",
            value: "presenzaWorkshop",
            sortable: false
        },
        {
          text: "Elimina schedule",
          value: "deleteScheduleWorkshop",
          sortable: false
        }
        // {
        //   text: "Test",
        //   value:"testWorkshop"
        // }
      ],
      records: [],
      filterType: "questionariWorkshopAziende",
      listaArticolazioni: [
        {
          idArticolazione: "Tutte",
          nomeArticolazione: "Tutte"
        }
      ],
      listaGiorni: [
        {
          idGiorno: 'Tutti',
          descrizioneGiorno: 'Tutti'
        }
      ],
      type: "workshop"
    };
    this.createDialogParams = {
      visible: false,
      type: ""
    };
    this.listaIscrizioniWorkshop = [];
    this.listaGiorni = [];
    this.listaTurni = [];
    this.changed = false;
    this.errorOccured = false;
    this.userInfo = null;
  }

  loadSchedulazioneWorkshop() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var instituteInfo: InstituteInfo = user.readInstituteInfo(this["$store"]);
    var payload = {
      idIstituto: instituteInfo.id,
      idAnnoScolastico: idAnnoScolastico
    };
    data
      .dispatchListaIscrizioniWorkshop(this["$store"], payload)
      .then(result => {
        this.listaIscrizioniWorkshop = result;
        this.dataTableParams.records = result;
        bus.$emit("dataLoadedSchedule");
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  loadGiorni() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var instituteInfo: InstituteInfo = user.readInstituteInfo(this["$store"]);
    var payload = {
      idIstituto: instituteInfo.id,
      idAnnoScolastico: idAnnoScolastico
    };
    data
      .dispatchGiorniWorkshop(this["$store"], payload)
      .then(result => {
        this.listaGiorni = result;
        result.forEach((element:any) => {
          this.dataTableParams.listaGiorni.push(element);
        });
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  loadTurni() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var instituteInfo: InstituteInfo = user.readInstituteInfo(this["$store"]);
    var payload = {
      idIstituto: instituteInfo.id,
      idAnnoScolastico: idAnnoScolastico
    };
    data
      .dispatchTurniWorkshop(this["$store"], payload)
      .then(result => {
        this.listaTurni = result;
        
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  save() {
    bus.$emit("saveSchedule")
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var instituteInfo: InstituteInfo = user.readInstituteInfo(this["$store"]);
    this.dataTableParams.records.forEach((element: any) => {
      var payload = {
        idInformazioneWorkshop: element.idInformazioneWorkshop,
        idTurno: element.idTurno,
        idGiorno: element.idGiorno
      };
      user
        .dispatchSaveScheduleWorkshop(this["$store"], payload)
        .then(() => {})
        .catch(error => {
          this.errorOccured = true;
          if (error.response.status === 403) {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          }
        });
    });
    if (this.errorOccured === true) {
      this.errorOccured = false;
      bus.$emit(
        "errorOperation",
        "Si sono verificati alcuni errori nel salvataggio di uno o più schedulazioni. Rieseguire il salvataggio"
      );
    } else {
      bus.$emit("successfullOperation", "Schedulazioni salvate con successo");
      this.changed = false;
    }
  }

  created() {
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        this.userInfo = user.readUserInfo(this["$store"]) 
        user
          .dispatchSetInstituteInfo(this["$store"])
          .then(() => {
            var instituteInfo = user.readInstituteInfo(this["$store"]);
            data
              .dispatchArticolazioni(this["$store"], instituteInfo.id)
              .then(response => {
                response.forEach(element => {
                  this.dataTableParams.listaArticolazioni.push(element);
                });
                this.loadSchedulazioneWorkshop();
                this.loadGiorni();
                this.loadTurni();
              });
            bus.$emit("loadMenu");
          })
          .catch(() => {
            bus.$emit("stopLoading");
            auth.dispatchLogout(this["$store"]);
            user.dispatchClearState(this["$store"]);
            this["$router"].push("/sessionExpired");
          });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });

    bus.$on("filtroIscrizioniWorkshop", (filters: any) => {
      const listaIscrizioniWorkshop: any = this.listaIscrizioniWorkshop;
      var tempList: any = [];
      var tempList2: any = []; 
      this.dataTableParams.records = [];
      listaIscrizioniWorkshop.forEach((item: any) => {
        if (filters.fitroArticolazione !== "Tutte") {
          if (filters.fitroArticolazione === "IT01") {
            if (item.idArticolazione === "IT01") {
              tempList.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT04") {
            if (item.idArticolazione === "IT04") {
              tempList.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT05") {
            if (item.idArticolazione === "IT05") {
              tempList.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT10") {
            if (item.idArticolazione === "IT10") {
              tempList.push(item);
            }
          }
          if (filters.fitroArticolazione === "IT13") {
            if (item.idArticolazione === "IT13") {
              tempList.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITAF") {
            if (item.idArticolazione === "ITAF") {
              tempList.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITEN") {
            if (item.idArticolazione === "ITEN") {
              tempList.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITET") {
            if (item.idArticolazione === "ITET") {
              tempList.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITIA") {
            if (item.idArticolazione === "ITIA") {
              tempList.push(item);
            }
          }
          if (filters.fitroArticolazione === "ITMM") {
            if (item.idArticolazione === "ITMM") {
              tempList.push(item);
            }
          }
          if (filters.fitroArticolazione === "LI03") {
            if (item.idArticolazione === "LI03") {
              tempList.push(item);
            }
          }
        } else {
          tempList.push(item);
        }
      });
      tempList.forEach((item:any) => {
        if(filters.filtroGiorno !== 'Tutti'){
          if (item.giorno === filters.filtroGiorno) {
            tempList2.push(item)
          } 
        }else{
          tempList2.push(item)
        }
      });
      this.dataTableParams.records = tempList2;
    });

    bus.$on("loadSchedulazioneWorkshop", () => {
      this.loadSchedulazioneWorkshop();
    });

    bus.$on("loadGiorni", () => {
      this.loadGiorni();
    });

    bus.$on("loadTurni", () => {
      this.loadTurni();
    });

    bus.$on("scheduleChanged", () => {
      this.changed = true;
    });
  }
}
